import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import Lottie from "lottie-react";
import success from "../../../../assets/lottie/success.json";
import error from "../../../../assets/lottie/error.json";
import { primaryButtonStyles } from "../../../../Styles/Styles";

export default function ResultModal({ open, type, message, onClose, onSave }) {
  const handleClose = () => {
    onClose();
    onSave();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="result-dialog"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: 4,
        }}
      >
        <Lottie
          animationData={type === "success" ? success : error}
          style={{ width: 120, height: 120 }}
          loop={false}
        />
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "ClashGrotesk-Regular",
            textAlign: "center",
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{
            ...primaryButtonStyles,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
